import {useSelector} from 'react-redux'
import { selectCurrentToken } from '../features/auth/authSlice'
import {jwtDecode} from 'jwt-decode'

const useAuth = () => {
  const token = useSelector(selectCurrentToken)
  let isManager = false
  let isAdmin = false
  let status = 'Employee'

  if(token){
    const decoded = jwtDecode(token)
    const {username, roles } = decoded.UserInfo
    
    isManager = roles.includes('Manager')
    // The includes() method determines whether a string or an array contains a specified value, returning true or false as appropriate
    isAdmin = roles.includes('Admin')

    if(isManager) status = 'Mananger'
    if(isAdmin) status = 'Admin'
    //this will be returned if we have a token
    return {username, roles, status, isManager, isAdmin}

  }



  //   This will be what we return if we dont have a token
  return {username: '', roles:[], isManager, isAdmin, status}
}

export default useAuth